import {createStyles} from '@mantine/core';
import React from 'react';

export const BENCHLING_AI_CLIENT_ID = 'benchling-ai';
export const BENCHLING_AI_HELP_URL =
  'https://help.benchling.com/hc/en-us/articles/45766024411405-Use-Benchling-AI-chat';

export interface VersionHistoryOAuthClientAttributionProps {
  oauth2ClientId?: string;
  oauth2ClientName?: string;
}

const useStyles = createStyles((theme) => ({
  attribution: {
    color: theme.colors.gray[5],
  },
  attributionLink: {
    color: theme.colors.gray[5],
  },
}));

function VersionHistoryOAuthClientAttribution({
  oauth2ClientId,
  oauth2ClientName,
}: VersionHistoryOAuthClientAttributionProps): JSX.Element | null {
  const {classes} = useStyles();

  if (oauth2ClientName == null) {
    return null;
  }

  const clientLabel =
    oauth2ClientId === BENCHLING_AI_CLIENT_ID ? (
      <a
        className={classes.attributionLink}
        href={BENCHLING_AI_HELP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {oauth2ClientName}
      </a>
    ) : (
      oauth2ClientName
    );

  return <span className={classes.attribution}> via {clientLabel}</span>;
}

export default VersionHistoryOAuthClientAttribution;
